import PropTypes from 'prop-types';
import ArrowRightIcon from 'src/assets/icons/ArrowRight.svg';

import TrackKeys from '.';
const FALLBACK_IMG =
  'https://www.aalforum.eu/wp-content/uploads/2016/04/profile-placeholder.png';
export const HEX_COLOR_CHECK = /^#([0-9a-f]{3}){1,2}$/i;
const TrackKey = ({ track, toggleOpen, isSubTrack, user }) => {
  const {
    title,
    tracks,
    isOpen,
    avatar: trackAvatar,
    isProjectUser,
    bg_color,
  } = track;
  const { name, avatar, isProject } = user;
  const isExpandable = isOpen !== undefined;

  return (
    <li>
      <div className={`h-10 pl-4 ${isSubTrack ? '' : 'border-t'}`}>
        {/* Track */}
        {isExpandable && (
          <div className=" flex h-full items-center ">
            <button
              title="Expand"
              onClick={() => toggleOpen(track)}
              type="button"
            >
              <img
                src={ArrowRightIcon}
                alt="toggle-arrow-icon"
                className={`transition-all${isOpen ? ' rotate-90' : ''}`}
              />
            </button>
            <div>
              {!isProject && (
                <img
                  className="ml-2 h-6 w-6 rounded-full"
                  src={avatar ?? FALLBACK_IMG}
                  alt="userImg"
                />
              )}
            </div>
            <p className=" font-SFProDisplay_Medium ml-2 text-sm">{name}</p>
          </div>
        )}
        {/* Sub-Track */}
        {!isExpandable && (
          <div className="ml-3 flex h-full items-center space-x-2">
            {isProjectUser && (
              <img
                className="ml-2 h-6 w-6 rounded-full"
                src={trackAvatar ?? FALLBACK_IMG}
                alt="userImg"
              />
            )}

            <p className="font-SFProDisplay_Medium text-sm">{title}</p>
            {!isProjectUser && (
              <div
                style={{
                  backgroundColor: HEX_COLOR_CHECK.test(bg_color)
                    ? bg_color
                    : ' rgb(76 78 180)',
                }}
                className={`h-1.5 w-5`}
              />
            )}
          </div>
        )}
      </div>
      {isOpen && (tracks ?? []).length > 0 && (
        <TrackKeys tracks={tracks} toggleOpen={toggleOpen} isSubTrack />
      )}
    </li>
  );
};

TrackKey.propTypes = {
  track: PropTypes.shape({
    title: PropTypes.string.isRequired,
    tracks: PropTypes.arrayOf(PropTypes.shape({})),
    isOpen: PropTypes.bool,
    hasButton: PropTypes.bool,
    sideComponent: PropTypes.element,
  }),
  toggleOpen: PropTypes.func,
  clickTrackButton: PropTypes.func,
};

TrackKey.defaultProps = {
  clickTrackButton: undefined,
};

export default TrackKey;
